import React from 'react';
import { Button, Result } from 'antd';
import { FormattedMessage } from 'react-intl';
import { rgPermissionCodes } from 'src/consts/rgMenu';
import { useSelector } from 'react-redux';
import { rgPermissionsSelector } from 'src/selector/rgUser';

const UnauthorizedRg = ({ router, isTitleEmpty, subTitleId, showBackBtn }) => {
  const { curPermissions } = useSelector(rgPermissionsSelector);

  const handleClickBack = () => {
    if (!curPermissions.length) {
      router.replace('/');
    } else {
      const firstPermission = curPermissions[0];
      const path = Object.keys(rgPermissionCodes).find((key) => rgPermissionCodes[key] === firstPermission);
      router.replace(path || '/');
    }
  };

  return (
    <Result
      status="403"
      title={isTitleEmpty ? '' : '403'}
      subTitle={<FormattedMessage id={subTitleId || 'page403.subtitle'} />}
      extra={
        showBackBtn && (
          <Button type="primary" onClick={() => handleClickBack()}>
            <FormattedMessage id="action.backHome" />
          </Button>
        )
      }
    />
  );
};

export default UnauthorizedRg;
